import { themeGet } from '@styled-system/theme-get';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { InputWrapper, RemoveButton } from './StyledComponents';
import TextInput from '../../../../shared/FormStyles/TextInput.jsx';
import { Button } from '../../../../shared/FormStyles';
import { useCampaignContext } from '../../contexts/CampaignContext.jsx';

const PRIZE_LENGTH = 200;
const OTHER_LENGTH = 300;

const PrizeForm = ({
  isShow,
  values,
  handleChange,
  handleChangePrize,
  addPrize,
  removePrize,
  inputError,
}) => {
  const { t } = useTranslation(['prizes']);
  const { campaign } = useCampaignContext();
  const isDisabled = campaign.isArchived || !!campaign.deletedAt;

  return (
    <Container>
      {values.prizeDescriptions.map((_, index) => {
        return (
          <div key={index}>
            {index > 0 && !isShow && !isDisabled && (
              <RemoveButton
                onClick={() => {
                  removePrize(index);
                }}
              >
                {t('prizes:form.removePrize')}
              </RemoveButton>
            )}
            <TextInput
              label={t('prizes:form.prizeDescription')}
              charactersLimit={PRIZE_LENGTH}
              name="prize-descriptions"
              onChange={event => handleChangePrize(event, index)}
              value={values.prizeDescriptions[index]}
              placeholder={t('prizes:form.prizeDescriptionPlaceholder')}
              disabled={isDisabled}
              error={
                inputError('prizeDescriptions') &&
                inputError('prizeDescriptions')[index]
              }
            />
          </div>
        );
      })}
      {
        <AddButton
          disabled={isDisabled}
          onClick={() => {
            addPrize();
          }}
        >
          {t('prizes:form.addPrize')}
        </AddButton>
      }
      <InputWrapper>
        <TextInput
          label={t('prizes:form.message')}
          name="message"
          onChange={handleChange}
          value={values.message}
          disabled={isDisabled}
          as="textarea"
          charactersLimit={OTHER_LENGTH}
        />
      </InputWrapper>
    </Container>
  );
};

export default PrizeForm;

const Container = styled.div`
  width: 100%;
`;

const AddButton = styled(Button)`
  width: 100%;
  margin: 15px 0;
  background: ${themeGet('colors.primary.100')};

  &:disabled {
    opacity: 0.24;
    pointer-events: none;
  }
`;
